import { render, staticRenderFns } from "./TabBeneficiaryHistoryAutoTopUps.vue?vue&type=template&id=45e81fb8&"
import script from "./TabBeneficiaryHistoryAutoTopUps.vue?vue&type=script&lang=js&"
export * from "./TabBeneficiaryHistoryAutoTopUps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports